// Binds the app's hotkey registration, recorder calls and persistence into @heidi/dictate's hotkey ports; imported for effect in _app.tsx.
// `useMutateUpdateSettings` is already on `_app`'s static graph via
// `workspace-data-wiring`, so binding it here adds nothing to `/_app`.
import { useMutateUpdateSettings } from '@/hooks/mutation/useMutateUpdateSettings';
import {
  listenChordCommitted,
  listenKeyCapture,
  setDictationHotkey,
  startKeyRecording,
  stopKeyRecording,
} from '@/tauri/dictation/api';
import {
  configureDictationHotkeyPorts,
  type DictationHotkeySettingsUpdate,
} from '@heidi/dictate';
import { useCallback } from 'react';

export const usePersistDictationHotkeys = () => {
  const { mutateAsync } = useMutateUpdateSettings();
  return useCallback(
    (payload: DictationHotkeySettingsUpdate) => mutateAsync(payload),
    [mutateAsync]
  );
};

configureDictationHotkeyPorts({
  setDictationHotkey,
  usePersistDictationHotkeys,
  listenKeyCapture,
  listenChordCommitted,
  startKeyRecording,
  stopKeyRecording,
});
